import React, { useEffect, useState } from 'react'
import { getApi } from '../../../../api/call.api'
import { urlApi } from '../../../../api/url.api'
import TableComponent from '../../../../components/DataTable/TableComponent'
import Pagination from '../../../../components/Pagination/Pagination'
import { dateTimeConverter } from '../../../../utils/dateTimeConverter'
import IconButton from '../../../../components/Buttons/IconButton'
import { IconEye } from '@tabler/icons-react'

const ChatOperatorReport = ({ setSelectedOperator, selectedOperator }) => {

    const [userList, setUserList] = useState({
        items: [], count: 0
    })
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const getList = async () => {
        let resp = await getApi(urlApi.chatOperatorList + "?page=" + activePage + "&limit=" + perPage);
        if (resp?.responseCode === 200) {
            setUserList({
                items: resp?.data?.items,
                count: resp?.data?.count
            })
        } else {
            setUserList({
                items: [],
                count: 0
            })
        }
    }

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    useEffect(() => {
        getList();
    }, [activePage])

    const columns = [
        { name: "Sl. No", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Name", selector: (row) => row?.name, cell: (row) => (
                <div className="flex items-center gap-2">
                    <img src={row?.profilePic || "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg"} className='w-10 aspect-square rounded-full my-1 object-cover' alt="" />
                    <div>
                        <p className="mb-0">{row?.name || "OPERATOR"}</p>
                    </div>
                </div>
            )
        }, {
            name: "Active Days", selector: (row) => row?.activeDays, center: true, cell: (row) => (
                <p className="mb-1.5">{row?.activeDays ?? "0"}</p>
            )
        }, {
            name: "Chat Involved", selector: (row) => row?.chatInvolved, center: true, cell: (row) => (
                <p className="mb-1.5">{row?.chatInvolved ?? "0"}</p>
            )
        }, {
            name: "Chat Opened", selector: (row) => row?.chatOpened, center: true, cell: (row) => (
                <p className="mb-1.5">{row?.chatOpened ?? "0"}</p>
            )
        }, {
            name: "Online Duration", selector: (row) => row?.onlineDuration, center: true, cell: (row) => (
                <p className="mb-1.5">{Math.floor(row?.onlineDuration) || 0} h</p>
            )
        }, {
            name: "Last Online", selector: (row) => row?.lastOnline, center: true, cell: (row) => (
                <p className="mb-1.5">{dateTimeConverter(row?.lastOnline)}</p>
            )
        }, {
            name: "Status", selector: (row) => row?.isActive, center: true, cell: (row) => (
                <p className={`mb-1.5 font-semibold ${row?.isActive ? "text-green-600" : "text-red-600"}`}>{row?.isActive ? "ACTIVE" : "INACTIVE"}</p>
            )
        }, {
            name: "Details", selector: (row) => row?.lastOnline, center: true, cell: (row) => (
                <IconButton cssClass={`${selectedOperator?._id == row?._id && '!border-green-600'}`} icon={<IconEye size={18} className={`${selectedOperator?._id == row?._id && 'text-green-500'}`} />} onClickFunction={() => setSelectedOperator(row)} />
            )
        }]

    return (
        <div className='!mb-4'>
            <TableComponent
                isHeader={true}
                columns={columns}
                data={userList.items}
                totalRows={userList.count}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

            <Pagination itemsPerPage={perPage} totalCount={userList.count} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </div>
    )
}

export default ChatOperatorReport